import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=1cf412ea&scoped=true&lang=html"
import script from "./ProfileView.vue?vue&type=script&lang=js"
export * from "./ProfileView.vue?vue&type=script&lang=js"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=1cf412ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf412ea",
  null
  
)

export default component.exports